import React from "react";
import { BrowserRouter } from "react-router";
import { ThemeProvider as Mui5ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

import { NotificationProvider } from "../contexts/notification";
import "../components/globalStyles.css";
import ScrollReset from "../components/ScrollReset";
import { AuthProvider } from "../contexts/JWTAuthContext";
import { AccessLinkProvider } from "../contexts/AccessLinkContext";
import { PermissionsProvider } from "../contexts/permissions";
import ApolloProvider from "../share/ApolloProvider";
import routes, { renderRoutes } from "../routes";
import { CustomFieldsProvider } from "../contexts/customFields";
import { BannerProvider } from "../contexts/banner";
import { NotificationCenterProvider } from "../contexts/notificationCenter";
import IntercomMessenger from "./IntercomMessenger";
import AppVersionBanner from "../components/AppVersionBanner";
import appThemeMui5 from "../theme/appThemeMui5";

const AppContent = () => {
  return (
    <ApolloProvider>
      <StyledEngineProvider injectFirst>
        <Mui5ThemeProvider theme={appThemeMui5}>
          <BannerProvider>
            <AppVersionBanner />
            <NotificationProvider>
              <BrowserRouter>
                <AccessLinkProvider>
                  <AuthProvider>
                    <PermissionsProvider>
                      <CustomFieldsProvider>
                        <NotificationCenterProvider>
                          <ScrollReset />
                          <IntercomMessenger />
                          {renderRoutes(routes)}
                        </NotificationCenterProvider>
                      </CustomFieldsProvider>
                    </PermissionsProvider>
                  </AuthProvider>
                </AccessLinkProvider>
              </BrowserRouter>
            </NotificationProvider>
          </BannerProvider>
        </Mui5ThemeProvider>
      </StyledEngineProvider>
    </ApolloProvider>
  );
};

export default AppContent;
